(function() {
  'use strict';

  angular
    .module('coinfundSlack', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'restangular',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'coinfundSlack.config'
    ]);

})();

/*
* @Author: Jake Brukhman
* @Date:   2017-01-14 21:30:22
* @Last Modified by:   Jake Brukhman
* @Last Modified time: 2017-01-22 19:03:50
*/

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .directive('tipsList', tipsList);

  /** @ngInject */
  function tipsList() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/tips/tipsList.html',
      scope: {
        tipsData: '='
      },
      link: function() {
      }
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .controller('TipsController', TipsController);

  /** @ngInject */
  function TipsController(Restangular, $log) {
    var vm = this;
    Restangular.one('api/tips').get().then(function(data) {
      vm.data = data;
      $log.log(data);
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .controller('StatsController', StatsController);

  /** @ngInject */
  function StatsController(Restangular, $log) {
    var vm = this;
    Restangular.one('api/slack/stats').get().then(function(data) {
      vm.data = data;
      $log.log(data);
    });
  }

})();

/*
* @Author: Jake Brukhman
* @Date:   2017-01-14 21:30:22
* @Last Modified by:   Jake Brukhman
* @Last Modified time: 2017-01-22 14:54:04
*/

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .directive('channelsList', channelsList);

  /** @ngInject */
  function channelsList() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/stats/channelsList.html',
      scope: {
        channelsData: '='
      },
      link: function() {
      }
    };
    return directive;
  }

})();

/*
* @Author: Jake Brukhman
* @Date:   2017-01-14 21:30:22
* @Last Modified by:   Jake Brukhman
* @Last Modified time: 2017-01-22 14:15:05
*/

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .directive('invites', invites);

  /** @ngInject */
  function invites($log, $state, $http, Config) {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/invites/invites.html',
      scope: true,
      link: function(scope) {

        scope.requestInvite = function(email) {
          $log.log('email', email);
          if (angular.isUndefined(email)) {
            $log.log('no email entered');
            return;
          }

          var ep = Config.apiEndpoint + 'api/slack/invite';
          $http.post(ep, {email: email})
            .then(function() {
              scope.done = true;
            }, function(err) {
              scope.err = err;
              if (!err.data) {
                scope.genericError = true;
                return;
              }
              if (!err.data.ok) {
                if (err.data.err === 'invalid_email') {
                  scope.invalidEmail = true;
                } else if (err.data.err === 'already_invited') {
                  scope.alreadyInvited = true;
                }
              }
            });
        };

        scope.tryAgain = function() {
          $state.reload();
        };


      }
    };
    return directive;
  }

})();

/*
* @Author: Jake Brukhman
* @Date:   2017-01-14 23:20:05
* @Last Modified by:   Jake Brukhman
* @Last Modified time: 2017-01-15 18:57:34
*/


(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .directive('donation', donation);

  /** @ngInject */
  function donation() {
    var directive = {
      restrict: 'EA',
      controller: DonationCtrl,
      scope: {
        logo: '@'
      },
      replace: true,
      templateUrl: 'app/components/donations/donation.html'
    };
    return directive;

    /** @ngInject */
    function DonationCtrl() {

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(Restangular, $log) {
    var vm = this;
    Restangular.one('api/slack').get().then(function(data) {
      vm.data = data;
      $log.log(data);
    });
  }

})();

angular.module("coinfundSlack.config", [])
.constant("Config", {"apiEndpoint":"https://coinfund-api.herokuapp.com/"});

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('coinfundSlack')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'ctrl'
      })
      .state('stats', {
        url: '/stats',
        templateUrl: 'app/components/stats/stats.html',
        controller: 'StatsController',
        controllerAs: 'ctrl'
      })
      .state('tips', {
        url: '/tips',
        templateUrl: 'app/components/tips/tips.html',
        controller: 'TipsController',
        controllerAs: 'ctrl'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/*  */
(function() {
  'use strict';

  angular
    .module('coinfundSlack');
    // .constant('malarkey', malarkey)
    // .constant('moment', moment);

})();

(function() {
  'use strict';

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // TODO(jbrukh): config
  }

  /** @ngInject */
  function configRestangular(Config, RestangularProvider) {
    var url = Config.apiEndpoint;
    RestangularProvider.setBaseUrl(url);
  }

  /** @ngInject */
  function configHtml5($locationProvider) {
    $locationProvider.html5Mode(true).hashPrefix('!');
  }

  angular
    .module('coinfundSlack')
    .config(config)
    .config(configHtml5)
    .config(configRestangular);

})();

angular.module("coinfundSlack").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"row main\"><a href=http://coinfund.io><img src=assets/images/coinfund-logo-padded.png class=logo></a><img src=assets/images/slack.png class=slack><div class=\"divider black\"></div><div class=info>We are an open community for blockchain technology research.</div><div class=vspace-1>Please reach out to <a href=mailto:info@coinfund.io>info@coinfund.io</a> for access.</div><div class=vspace-1>Or you may <a href=https://coinfund.slack.com>sign in</a> to CoinFund Slack.</div><div class=\"slackinfo vspace-2\" ng-if=ctrl.data><div><span class=online>{{ctrl.data.users_online}}</span> of <b>{{ctrl.data.users}}</b> members online across <b>{{ctrl.data.channels}}</b> channels.</div><div ng-if=ctrl.data.most_popular><b>#{{ctrl.data.most_popular}}</b> is popular, with <b>{{ctrl.data.max_users}}</b> researchers.</div><a class=button ui-sref=stats>TOP CHANNELS</a> <a class=button ui-sref=tips>LEADERBOARD</a></div></div>");
$templateCache.put("app/components/donations/donation.html","<img class=donation ng-src={{logo}}>");
$templateCache.put("app/components/invites/invites.html","<div class=invites><div ng-show=\"!done && !err\"><input class=email type=text placeholder=you@yourdomain.com autofocus ng-model=email ng-keyup=\"$event.keyCode == 13 && requestInvite(email)\"><div class=\"btn btn-warning vspace-1\" ng-click=requestInvite(email)>Request an Invite</div></div><div ng-show=done><h4>Your email has been submitted.</h4></div><div ng-show=err><h4 ng-show=genericError>There was a problem submitting your email. Please contact <a href=mailto:info@coinfund.io>info@coinfund.io</a>.</h4><h4 ng-show=alreadyInvited>The email {{email}} has already been invited. <a ng-click=tryAgain()>Try again.</a></h4><h4 ng-show=invalidEmail>The email {{email}} is invalid. <a ng-click=tryAgain()>Try again.</a></h4></div></div>");
$templateCache.put("app/components/stats/channelsList.html","<div class=channels-list><h3 class=title>Top Research Channels</h3><div class=\"cont col-xs-12 col-sm-offset-3 col-sm-6 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8\"><table class=table><tr ng-repeat=\"ch in channelsData.channels | limitTo: 10\"><td class=index>{{$index+1}}</td><td class=channel-name>#{{ch.name}}</td><td><b>{{ch.members}}</b> researchers</td></tr><tr><td colspan=3><a class=button ui-sref=home>BACK</a><a class=button ui-sref=tips>LEADERBOARD</a></td></tr></table></div></div>");
$templateCache.put("app/components/stats/stats.html","<div class=\"row main\"><a href=http://coinfund.io><img src=assets/images/coinfund-logo-padded.png class=logo></a><img src=assets/images/slack.png class=slack><div class=\"divider black\"></div><div class=slackstats><div channels-list channels-data=ctrl.data></div></div></div>");
$templateCache.put("app/components/tips/tips.html","<div class=\"row main\"><a href=http://coinfund.io><img src=assets/images/coinfund-logo-padded.png class=logo></a><img src=assets/images/slack.png class=slack><div class=\"divider black\"></div><div class=tipstats><div tips-list tips-data=ctrl.data></div></div></div>");
$templateCache.put("app/components/tips/tipsList.html","<div class=tips-list><h3 class=title>CoinFund Tip Balances</h3><div class=\"cont col-xs-12 col-sm-offset-3 col-sm-6 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8\"><table class=table><tr ng-repeat=\"user in tipsData.leaderboard | limitTo: 10\"><td class=index>{{$index+1}}</td><td class=channel-name>{{user.name}}</td><td><b>{{user.bits}}</b> bits</td><td>${{user.usd | number:2}}</td></tr><tr><td colspan=4><a class=button ui-sref=home>BACK</a> <a class=button ui-sref=stats>TOP CHANNELS</a></td></tr></table></div></div>");}]);